import React from 'react';
import List from '@mui/material/List';

import routesConfig, {NavItemProps} from '../../../../modules/routesConfig';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import VerticalNavGroup from './VerticalNavGroup';
import VerticalHeader from './VerticalHeader';

interface NavigationProps {}

const Navigation: React.FC<NavigationProps> = () => {
  return (
    <List>
      {routesConfig.map((item: NavItemProps) => (
        <React.Fragment key={item.id}>
          {item.type === 'header' && <VerticalHeader item={item} level={0} />}

          {item.type === 'group' && <VerticalNavGroup item={item} level={0} />}

          {item.type === 'collapse' && (
            <VerticalCollapse item={item} level={0} />
          )}

          {item.type === 'item' && <VerticalItem item={item} level={0} />}
        </React.Fragment>
      ))}
    </List>
  );
};

export default Navigation;
